export const inViewOptions = {
    threshold: 0.3,
    triggerOnce: true,
}